module.exports = __webpack_public_path__ + "media/customizations/fsr/back-952bbba5710a9980a63e2c9347eb87df.jpg";